/**
 * Grouping nouns that represent subjects/topics in field labels.
 * These create primary groupings by identifying the main subject of a field.
 * Can appear as prefixes (e.g., "Employer Name", "Spouse Address")
 * or as topics (e.g., "Start Date of Employment", "Date of Marriage")
 */
export const GROUPING_NOUNS = [
  // People/Entities
  'Employer',
  'Employee',
  'Spouse',
  'Company',
  'Foreign',
  'Father',
  'Mother',
  'Child',
  'Parent',
  // Descriptors/Modifiers
  'Mailing',
  'Previous',
  // Life Events/Topics
  'Employment',
  'Residence',
  'Marriage',
  'Birth',
  'Death',
  'Arrival',
  'Departure',
  'Entry',
  'Exit',
];

/**
 * Predefined field order for the populate page.
 * Fields are ordered by logical grouping (name, address, contact, identifying info, dates).
 * This is a temporary solve until the tag architecture itself can address this
 * DRINT-783 for more context as well as the google doc that defines the order
 */
export const FIELD_ORDER = [
  // Name Fields
  'Name',
  'First Name',
  'Middle Name',
  'Last Name',
  'Full Name',
  'Display Name',
  'Title',
  'Previous Names',
  'Company Name',
  'Court Name',
  'Judge Name',
  'Magistrate Name',
  'Firm Name',
  'Aliases',
  'DBA',
  'Known As',
  'Unmarried Name',
  'Personal Pronoun',
  // Address/Location Fields
  'Address',
  'Street Address',
  'City',
  'State',
  'County',
  'Zip Code',
  'Postal Code',
  'Country',
  'Previous Address',
  'Mailing Address',
  'Court Division',
  'Court Department',
  'Court Branch',
  'Address when Died',
  'State of Incorporation',
  'Place of Injury',
  // Contact Information Fields
  'Phone Number',
  'Cell Number',
  'Mobile Number',
  'Work Number',
  'Secondary Phone',
  'Email',
  'Fax Number',
  // Identifying Information
  'Social Security Number',
  'Drivers License Number',
  'Drivers License State',
  'Alien Number',
  'State Bar Number',
  'Relationship',
  'Language',
  'Height',
  'Weight',
  'Hair Color',
  'Eye Color',
  'Occupation',
  'Employer FEIN',
  'Employer UI Id Number',
  'Insurer Policy Number',
  'Legal Description',
  'Date of Birth',
  // Dates/Times
  'Start Date',
  'End Date',
  'Date of Hearing',
  'Date of Death',
  'Date of Incorporation',
  'Date of Will',
  'Date of Hire',
  'Date of Injury',
  'Time of Injury',
  'Date of Last Codicil',
  'Date of Arrival',
  'Date of Marriage',
  'Date Employment Began',
  'Date Employment Ended',
  'Date of last US entry',
  'Date of last US exit',
  'Last USA Entry Date',
  'Last USA Entry Place',
  'Last USA Entry Status',
  'Date Residence Began',
  'Date Residence Ended',
];
